import { IconLock } from './icons/LineIcons';
import './safeAndSecure.css';

/**
 * The line under a payment's button and on the card screen (Rio, 12 Oct
 * 2026): "something psychologically clean and calming in two or three
 * words", naming no payment company. The client's own wallet (EcoCash,
 * OneMoney) is still named where they must act, on the phone page.
 */
export const SAFE_AND_SECURE = 'Safe and secure';

export default function SafeAndSecure({ className = '' }) {
  return (
    <p className={`safe-and-secure ${className}`.trim()}>
      <IconLock />
      <span>{SAFE_AND_SECURE}</span>
    </p>
  );
}
